import { render } from "./CtaFooter.vue?vue&type=template&id=99f03ac8"
import script from "./CtaFooter.vue?vue&type=script&lang=js"
export * from "./CtaFooter.vue?vue&type=script&lang=js"

import "./CtaFooter.vue?vue&type=style&index=0&id=99f03ac8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__